export default "__VITE_ASSET__BUqf8mof__"